<template>
  <div class="nav-container row">
    <div class="nav-button home-btn"
         @click="goHome"
         :class="{'active':!isHome}"></div>
    <div class="nav-button pre-btn "
         @click="prevPage"
         :class="{'active':!isHome}"></div>
    <div class="nav-button-middle"
         v-click-outside="blur"
         @click="inputShow=true">
      {{pageString}}
      <input v-model="page"
             @keyup.enter="onSubmit"
             v-show="inputShow"
             @blur="blur" />
    </div>
    <div class="nav-button next-btn"
         @click="nextPage"
         :class="{'active':!isLast}"></div>
    <div class="nav-button end-btn "
         @click="goLast"
         :class="{'active':!isLast}"></div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import ClickOutside from 'vue-click-outside';

export default {
  name: 'navControl',
  props: {
    totalPage: Number,
    pageData: Array,
  },
  computed: {
    isHome() {
      return this.currentPage === 0;
    },
    isLast() {
      return this.currentPage === this.totalPage - 1;
    },
    currentPageShow() {
      let str;
      if (this.currentPage === 0) {
        str = this.pageData[this.currentPage].rightPage.cid
          ? this.pageData[this.currentPage].rightPage.cid
          : this.currentPage + 1;
      } else if (
        !this.pageData[this.currentPage].rightPage
        && this.currentPage === this.totalPage - 1
      ) {
        str = this.pageData[this.currentPage].leftPage.cid
          ? this.pageData[this.currentPage].leftPage.cid
          : this.currentPage * 2;
      } else {
        const se = Number(this.currentPage * 2 + 1);
        const first = this.pageData[this.currentPage].leftPage.cid
          ? this.pageData[this.currentPage].leftPage.cid
          : this.currentPage * 2;
        const second = this.pageData[this.currentPage].rightPage.cid
          ? this.pageData[this.currentPage].rightPage.cid
          : se;
        str = `${first}-${second}`;
      }
      return str;
    },
    pageString() {
      return `${this.currentPageShow}/${this.totalPage * 2 - 2}`;
    },
    ...mapState({
      currentPage: (state) => state.currentPage,
    }),
  },
  data() {
    return {
      current: this.$store.state.currentPage,
      page: '',
      inputShow: false,
    };
  },
  methods: {
    blur() {
      this.inputShow = false;
    },
    onSubmit() {
      if (!this.page) return;
      const n = Math.floor(this.page / 2);
      if (n < this.totalPage && n > -1) {
        this.goPage(n);
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPage) {
        this.goPage(Number(this.currentPage) + 1);
      }
    },
    prevPage() {
      if (this.currentPage > 0) {
        this.goPage(Number(this.currentPage) - 1);
      }
    },
    goHome() {
      if (!this.isHome) this.goPage(0);
    },
    goLast() {
      if (!this.isLast) {
        this.goPage(this.totalPage - 1);
      }
    },
    goPage(n) {
      if (n < this.totalPage && n > -1) {
        const leftId = this.pageData[n].leftPage
          ? this.pageData[n].leftPage.pageid
          : 'cover';
        const rightId = this.pageData[n].rightPage
          ? this.pageData[n].rightPage.pageid
          : 'back';
        const contentUrl = `/catalog/${this.$store.state.company_id}/${this.$store.state.code}/h5/small/${leftId}`;
        const rcontentUrl = `/catalog/${this.$store.state.company_id}/${this.$store.state.code}/h5/small/${rightId}`;
        // 百度统计
        if (window._hmt) {
          window._hmt.push([
            '_trackPageview',
            `/catalog/${this.$store.state.company_id}/${this.$store.state.code}/`,
          ]);
        }
        // google 统计
        if (window.ga) {
          window.ga('set', 'page', contentUrl);
          window.ga('send', 'pageview');
          window.ga('set', 'page', rcontentUrl);
          window.ga('send', 'pageview');
        }
        // google v4
        this.$gtag.pageview(contentUrl);
        this.$gtag.pageview(rcontentUrl);
        this.$store.commit('updateCurrentPage', { currentPage: n });
      }
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>
<style lang="less" scoped>
.nav-container {
  width: 250px;
  height: 30px;
  background: #090e18;
  display: flex;
  .nav-button {
    width: 30px;
    height: 30px;
    opacity: 0.4;
    cursor: pointer;
  }
  .nav-button.active {
    opacity: 0.8;
  }
  .nav-button.active:hover {
    opacity: 1;
  }
  .home-btn {
    background: url("~@/assets/icon/arrow-cover.png");
  }
  .pre-btn {
    margin-left: 3px;
    background: url("~@/assets/icon/prev.png");
  }
  .next-btn {
    background: url("~@/assets/icon/next.png");
    margin-left: 3px;
  }
  .end-btn {
    margin-left: 3px;
    background: url("~@/assets/icon/arrow-back.png");
  }
  .nav-button-middle {
    flex: 1;
    margin-left: 3px;
    height: 30px;
    width: 100px;
    background: #30353d;
    color: white;
    line-height: 30px;
    text-align: center;
    position: relative;
    input {
      position: absolute;
      left: 0px;
      height: 28px;
      background: #30353d;
      text-align: center;
      border: none;
      color: white;
      width: 100%;
      outline: none;
      box-sizing: border-box;
    }
  }
}
</style>
